<!-- Engraving section (if provided) -->
@if (engravingText) {
    <div class="engraving-section">
        <div class="engraving-content">
            <div class="engraving-icon">
                <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9.95573 1.76251C5.2474 1.76251 1.41406 5.59168 1.41406 10.3042C1.41406 15.0167 5.2474 18.8458 9.95573 18.8458C14.6641 18.8458 18.4974 15.0125 18.4974 10.3042C18.4974 5.59585 14.6682 1.76251 9.95573 1.76251ZM9.95573 17.5958C5.9349 17.5958 2.66406 14.325 2.66406 10.3042C2.66406 6.28335 5.9349 3.01251 9.95573 3.01251C13.9766 3.01251 17.2474 6.28335 17.2474 10.3042C17.2474 14.325 13.9766 17.5958 9.95573 17.5958Z"
                        fill="#2E2E2E"
                    />
                    <path
                        d="M14.0193 7.99585H5.89844C5.5526 7.99585 5.27344 8.27502 5.27344 8.62085C5.27344 8.96668 5.5526 9.24585 5.89844 9.24585H14.0193C14.3651 9.24585 14.6443 8.96668 14.6443 8.62085C14.6443 8.27502 14.3651 7.99585 14.0193 7.99585Z"
                        fill="#2E2E2E"
                    />
                    <path
                        d="M13.1969 11.3625H6.73438C6.38854 11.3625 6.10938 11.6417 6.10938 11.9875C6.10938 12.3333 6.38854 12.6125 6.73438 12.6125H13.1969C13.5427 12.6125 13.8219 12.3333 13.8219 11.9875C13.8219 11.6417 13.5427 11.3625 13.1969 11.3625Z"
                        fill="#2E2E2E"
                    />
                </svg>
            </div>
            <div class="engraving-details">
                <h4>Engraved</h4>
                @for (line of engravingLines(); track $index) {
                    <p class="engraving-line">{{ line }}</p>
                }
            </div>
            @if (isOrderReview) {
                <button class="view-engraving-btn" type="button" (click)="viewEngravingDetails()">View details</button>
            }
        </div>
    </div>
}

<!-- AppleCare section -->
@if (appleCareItem) {
    <div class="apple-care-listing">
        <div class="content">
            <div class="logo">
                <img
                    class="logo-image"
                    alt="{{ appleCareItem.brand }} {{ appleCareItem.model }}"
                    src="https://maxsite.b-cdn.net/Chase/Apple/Icons/applecare/AppleCare_Icon.png"
                />
            </div>

            <div class="details">
                <h4>{{ appleCareItem.productName }}</h4>
                <p>Automatically registered with your Apple hardware.</p>
            </div>
        </div>

        <div class="footer">
            <div class="pricing">
                <div class="price">{{ formatPrice(appleCareItem.price) }}</div>
            </div>
        </div>
    </div>
}
